import { Box, Stack, Typography } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

type TabsProps = PropsWithChildren & {
	message: string;
	color: string;
	sx?: object;
	icon?: JSX.Element;
	onClick?: () => void;
};

export const Alert: FC<TabsProps> = (props) => {
	const { message, color, sx, onClick, icon } = props;
	return (
		<Box
			bgcolor={`${color}.light`}
			color={`${color}.main`}
			textAlign="center"
			padding={1}
			onClick={() => onClick?.()}
			sx={{
				userSelect: "none",
				transition: "all 0.25s ease",
				boxShadow: (t) => `0 0 0 0 ${t.palette[color].light}33`,
				...sx,
			}}
		>
			<Stack direction="row" columnGap={1} alignItems="center">
				{icon && (
					<Box width="24px" height="24px" paddingLeft={0.5}>
						{icon}
					</Box>
				)}
				<Box width="100%">
					<Typography color={`${color}.main`}>{message}</Typography>
				</Box>
			</Stack>
		</Box>
	);
};
